<template>
  <div v-if="parentEntity" class="mt-3">
    <right-panel class="float-right" id="sidebar-new-process" width="600px" icon="" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form />
      </div>
    </right-panel>

    <right-panel class="float-right" id="sidebar-info-process" width="800px">
      <div class="pl-5 pr-5" v-if="infoItem">
        <h3 class="mb-5">
          <i class="bx bx-info-circle align-middle font-size-24 mr-2"></i>
          <span class="  text-primary">{{ infoItem.name | translate }}</span>

          {{ $t("process.info") }}
        </h3>

        <content-loading v-if="isInfoLoading" />
        <div v-else>
          <h5>{{ $t("process.used-places") }}</h5>
          <table v-if="info.docs.length > 0" class="table table-border table-striped">
            <thead class="bg-dark text-white">
              <tr>
                <th>{{ $t("unit.text") }}</th>
                <th>{{ $t("department.text") }}</th>
                <th class="text-center">{{ $t("common.edit") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="i in info.docs" :key="'info' + i._id">
                <td>
                  {{ i.unit.name | translate }}
                </td>

                <td>
                  {{ i.name | translate }}
                </td>
                <td style="text-align: center;">
                  <a href="javascript:;void(0);" @click="deleteByIdFromHierarchy(i)" v-b-tooltip.hover :title="$t('common.delete')">
                    <i class="bx bx-trash-alt text-danger"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <empty v-else width="200px">
            <h6 class="text-center">{{ $t("common.no-hierarchy") }}</h6>
          </empty>
        </div>
        <!-- Begin: Pagination -->

        <div v-if="info" class="row">
          <div class="col">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="infoRequest.options.page" :total-rows="info.totalDocs" :per-page="info.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
        <!-- End: Pagination -->
      </div>
    </right-panel>

    <!-- Begin : Inventory -->
    <template>
      <right-panel class="float-right" id="sidebar-process-inventory" width="1400px" icon="" @hidden="bulkUpdateRightPanelClosed">
        <BulkUpdateView v-if="selectedBox" @onUpdated="onBulkUpdated" />
      </right-panel>
    </template>
    <!-- End : Inventory -->
    <div class="ds-card">
      <div class="ds-card--title justify-content-between">
        <span>
          <i class="iconoir-center-align align-middle mr-3" style="color: #383A55; font-size: 1.5rem !important;"></i>
          <span v-html="$t('process.owned-list', { name: $options.filters.translate(parentEntity.name) })"> </span>
        </span>

        <div v-if="recommendationAvailable" class="d-flex align-items-center float-right">
          <div class="d-flex align-items-center">
            <label class="switch-label">{{ $t("common.recommendations") }}</label>
            <b-form-checkbox v-model="showRecommendationBoxes" name="check-button" switch class="switch"></b-form-checkbox>
          </div>
        </div>
      </div>
      <div>
        <div class="search2  mb-4" style=" width: 18.50rem;">
          <div class="search2--icon"><i class="iconoir-search"></i></div>
          <input class="search2--input" type="text" :placeholder="$t('common.search')" v-model="nameFilter" />
        </div>
      </div>

      <content-loading v-if="isLoading" />
      <div v-else-if="pagination" class="d-flex" style="gap: 1.25rem;flex-wrap: wrap;">
        <div v-for="item in pagination.docs" :key="item._id" :id="'popover-target-' + item._id" class="ds-card--item" :class="selectedBoxStyle(item)" @click="selectBox(item)">
          <div class="actions d-flex justify-content-end p-2" style="top:0">
            <div class="action" @click="redirectToRelatedFiles(item)" v-on:click.stop v-b-tooltip.hover :title="$t('file-manager.view-related-files')">
              <i class="iconoir-page"></i>
            </div>
          </div>
          <div class="text">{{ item.name | translate }}</div>
          <div class="actions d-flex justify-content-center">
            <div class="action" v-if="hasRemovePermission" @click="deleteById(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.delete')">
              <i class="iconoir-trash"></i>
            </div>
            <div class="action" v-if="hasUpdatePermission" @click="markAsComplete(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.completed')">
              <i :class="item.completed ? 'iconoir-check-circle' : 'iconoir-circle'"></i>
            </div>
            <div class="action" @click="fetchInfo(item.process)" v-on:click.stop v-b-toggle="'sidebar-info-process'" v-b-tooltip.hover :title="$t('process.used-places')">
              <i class="iconoir-info-circle"></i>
            </div>

            <div class="action" @click="edit(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.edit')">
              <i class="iconoir-edit-pencil"></i>
            </div>
            <div class="action" @click="showInventoryPanel(item)" v-on:click.stop v-b-tooltip.hover :title="$t('inventory.filter.inventory-features')">
              <i class="iconoir-network-right"></i>
            </div>
          </div>

          <b-popover :target="'popover-target-' + item._id" triggers="hover" placement="bottom" variant="secondary">
            <template #title> {{ $t("process.admins") }}</template>
            <table>
              <tr v-for="admin in item.admins" :key="'process-admin' + admin._id">
                <td><letter-avatar :name="admin.account.name" :image="admin.account.avatar" variant="secondary" /></td>
                <td class="text-center">{{ admin.account.name }}</td>
              </tr>
              <tr v-if="!item.admins || item.admins.length < 1">
                <span>
                  <b>
                    {{ $t("process.no-admin") }}
                  </b>
                </span>
              </tr>
            </table>
          </b-popover>
        </div>

        <div class="ds-card--item2" @click="openRightPanel">
          <i class="iconoir-plus" style="font-size: 1.75rem;"></i>
        </div>
      </div>

      <!-- Begin: Pagination -->

      <div v-if="pagination" class="row mt-4">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
          </ul>
        </div>
      </div>
      <!-- End: Pagination -->
      <recommendation-boxes
        v-if="parentEntity"
        :id="parentEntity._id"
        :show="showRecommendationBoxes"
        :level="libraryScopedState"
        :libraryScopedState="libraryScopedState"
        organizationScopedState="organizationDepartmentProcess"
        @interceptForSetParent="interceptForSetParent"
        @onAccepted="paginate"
        @copyToForm="copyToForm"
        :title="$t('process.recommendations')"
      />
    </div>
  </div>
</template>

<script>
import BulkUpdateView from "@modules/inventory/component/bulk-update/bulk-update-view";
import Form from "../../department-process/organization-department-process-form";
import RecommendationBoxes from "./recommendation-boxes";

export default {
  components: { Form, RecommendationBoxes, BulkUpdateView },
  data() {
    return {
      request: {
        options: { page: 1, limit: 17, sort: { name: "asc" } },
        query: {},
      },
      nameFilter: undefined,
      libraryScopedState: "process",
      showRecommendationBoxes: undefined,

      infoRequest: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: {},
      },
    };
  },
  computed: {
    recommendationAvailable() {
      const loading = this.$store.getters[`${this.libraryScopedState}/isLoading`];
      const recommendations = this.$store.getters[`${this.libraryScopedState}/recommendations`];

      if (loading) {
        return false;
      }
      if (recommendations && recommendations.docs && recommendations.docs.length > 0) {
        return true;
      }
      return false;
    },
    parentEntity() {
      return this.$store.getters["entityBoxes/department"];
    },
    pagination() {
      return this.$store.getters["organizationDepartmentProcess/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationDepartmentProcess/isLoading"];
    },

    hasUpdatePermission() {
      return true;
    },
    hasRemovePermission() {
      return true;
    },

    infoItem() {
      return this.$store.getters["organizationProcess/infoItem"];
    },
    info() {
      return this.$store.getters["organizationProcess/info"];
    },
    isInfoLoading() {
      return this.$store.getters["organizationProcess/isInfoLoading"];
    },
    selectedBox() {
      return this.$store.getters["entityBoxes/process"];
    },
  },
  watch: {
    async nameFilter(n, o) {
      this.debounce(() => this.handleNameFilterChanged(n, o));
    },
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    parentEntity(item) {
      this.debounce(() => this.paginate());
    },

    infoRequest: {
      deep: true,
      immediate: false,
      handler() {
        this.debounce(() => this.fetchInfo());
      },
    },
  },
  mounted() {},
  methods: {
    async handleNameFilterChanged(n, o) {
      this.$store.commit("entityBoxes/clearFrom", "process");
      this.$store.commit("organizationDepartmentProcess/selectedEntity", undefined);

      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };

        const selectedProcess = this.$store.getters["entityBoxes/process"];
        if (selectedProcess) {
          await this.selectBox(selectedProcess);
        }
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
    onBulkUpdated() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-process-inventory");
    },
    redirectToRelatedFiles(item) {
      const url = this.currentProduct ? `/${this.currentProduct.toLowerCase()}/file-manager` : "/organization/file-manager";
      this.$router.push({ path: url, query: { process: item._id, processName: item.name?.[this.currentLanguage] } });
    },
    async showInventoryPanel(item) {
      this.$store.commit("entityBoxes/process", item);
      this.$store.commit("organizationDepartmentProcess/selectedEntity", item);

      this.$store.commit("inventoryFilter/clear");
      this.$store.commit("inventoryFilter/department", item.department);
      this.$store.commit("inventoryFilter/process", item);

      this.$root.$emit("bv::toggle::collapse", "sidebar-process-inventory");
    },

    selectedBoxStyle(item) {
      let style = "";
      if (this.selectedBox?._id == item._id) {
        style = "bg-main text-white";
      } else if (item.completed) {
        style += " completed";
      }
      return style;
    },

    async paginate() {
      if (!this.parentEntity) {
        return;
      }
      const request = { ...this.request };
      request.query = {
        ...request.query,
        department: { value: { _id: this.parentEntity._id }, isObject: true },
      };

      await this.$store.dispatch("organizationDepartmentProcess/paginate", request);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationDepartmentProcess/delete", item._id);
        this.paginate();

        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },

    interceptForSetParent(payload) {
      payload.department = this.parentEntity;
    },

    async deleteByIdFromHierarchy(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationDepartmentProcess/delete", item.rel_id);
        this.$toast.success(this.$t("common.delete-successful"));
        this.fetchInfo();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: this.$t("common.delete-failed") });
      }
    },

    async markAsComplete(item) {
      try {
        await this.$store.dispatch("organizationDepartmentProcess/markAsComplete", item._id);
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    edit(item) {
      this.$store.commit("organizationDepartmentProcess/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-process");
    },

    rightPanelClosed() {
      this.paginate();
      this.$store.commit("organizationDepartmentProcess/editedEntity");
      this.$store.commit("organizationDepartmentProcess/copingEntity");
      // this.$store.dispatch("organizationDepartmentProcess/resetForm");
    },
    bulkUpdateRightPanelClosed() {
      this.$store.commit("inventoryFilter/clear");
    },

    selectBox(item) {
      this.$store.dispatch("entityBoxes/selectProcess", item);
    },

    fetchInfo(item) {
      if (!item) {
        item = this.infoItem;
      }
      this.$store.dispatch("organizationProcess/fetchInfo", { item, pagination: this.infoRequest });
    },

    copyToForm(item) {
      this.$store.commit(`organizationDepartmentProcess/copingEntity`, { ...item, libraryItem: item, _id: undefined, department: this.parentEntity });
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-process");
    },

    openRightPanel() {
      const department = this.$store.getters["entityBoxes/department"];
      this.$store.commit(`organizationDepartment/selectedEntity`, department);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-process");
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../organization-entities-view.scss");
</style>
